module.exports = __webpack_public_path__ + "img/Logo Search_Blue_Circle.9540de4d.png";